// import gsap from "gsap";
// import Swiper from "swiper/bundle";

/* global gsap, swiper: false */

const EFFECT_DURATION = 0.5;

export default class SliderWithTimer {
	constructor(swiper) {
		if (!swiper) return;
		this.swiper = swiper;
		this.section = this.swiper.closest(".flexible-section");
		this.slides = swiper.querySelectorAll(".swiper-slide");
		this.dataSettings =
			this.swiper?.dataset?.swiper && JSON.parse(this.swiper.dataset.swiper);
		this.customPagination = this.section.querySelector(".custom-pagination");

		this.backgrounds = Array.from(
			this.section.querySelector(".backgrounds").querySelectorAll(".background")
		);

		if (0 === this.slides.length) return;
		this.init();
		this.events();
	}

	init() {
		this.duration = this.dataSettings?.autoplay?.delay || 2000;

		this.dataSettings.on = {
			init: () => {
				Array.from(
					this.customPagination.querySelectorAll(".item")
				)[0].classList.add("active");

				Array.from(
					this.customPagination.querySelectorAll(".item .progress")
				).map((el) =>
					el.style.setProperty("--scale-duration", `${this.duration}ms`)
				);
			},
		};

		this.swiper = new Swiper(this.swiper, this.dataSettings);

		if (this.backgrounds) {
			this.backgrounds.map((el, index) => (el.style.zIndex = `-${index}`));
		}
	}

	events() {
		this.swiper.on("slideChange", (swiper) => {
			const newIdx = swiper.realIndex;
			const previousIdx = swiper.previousRealIndex;
			let bgsToMove = null;

			if (newIdx > previousIdx) {
				// move right
				bgsToMove = this.backgrounds.filter((el, index) => index < newIdx);

				gsap.to(bgsToMove, {
					duration: 1,
					opacity: 0,
				});
			} else {
				// move left
				bgsToMove = this.backgrounds.filter((el, index) => index >= newIdx);

				gsap.to(bgsToMove, {
					duration: 1,
					opacity: 1,
				});
			}

			Array.from(this.customPagination.querySelectorAll(".item")).map(
				(el, index) => {
					if (index === newIdx) {
						el.classList.add("active");
						el.querySelector(".progress").style.setProperty(
							"--scale-duration",
							`${this.duration}ms`
						);
					} else {
						el.classList.remove("active");
						el.querySelector(".progress").style.setProperty(
							"--scale-duration",
							`${this.duration / 10}ms`
						);
					}
				}
			);
		});

		Array.from(this.customPagination.querySelectorAll(".item")).map((el) =>
			el.addEventListener("click", (ev) =>
				this.swiper.slideTo(parseInt(el.dataset.index))
			)
		);
	}
}
